module.exports = __webpack_public_path__ + "static/media/INZ1000.dc0a9664.pdf";